import React, { useState } from "react";
import TestimonialContext from "./TestimonialContext";

const TestimonialState = (props) => {
  const [apiData, setApiData] = useState({ data: [], isLoading: false });

  const [fromData, setFormData] = useState({
    title: "",
    description: "",
    companyName: "",
    image: "",
    webId: localStorage.getItem("webId"),
  });
  const [id, setId] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [filter, setFilter] = useState("");
  return (
    <TestimonialContext.Provider
      value={{
        apiData,
        setApiData,
        fromData,
        setFormData,
        id,
        setId,
        isEdit,
        setIsEdit,
        filter,
        setFilter,
      }}
    >
      {props.children}
    </TestimonialContext.Provider>
  );
};

export default TestimonialState;
